export default __webpack_public_path__ + "static/airbubbles-6e4a90acb57d9815da6ba241951b1ab6.png";